/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React from "react";
import Script from "next/script";
import { Bouncy } from "ldrs/react";
import "ldrs/react/Bouncy.css";

declare global {
  interface Window {
    UberallStorefinserMount?: () => void;
    UberallStorefinderUnmount?: () => void;
    UberallStorefinderStart?: () => void;
    UberallStorefinderRestart?: () => void;
  }
}

interface BranchLocatorWidgetProps {
  uberallDataKey: string;
}

const BranchLocatorWidget: React.FC<BranchLocatorWidgetProps> = ({
  uberallDataKey,
}) => {
  const initUberall = () => {
    window.UberallStorefinderUnmount?.();
    window.UberallStorefinderStart?.();
    window.UberallStorefinderRestart?.();
  };

  return (
    <>
      <div
        className="min-h-[600px]"
        data-key={uberallDataKey}
        id="store-finder-widget"
      >
        <div
          className="flex flex-col items-center justify-center gap-5 w-full mt-32"
          style={{ display: "flex !important", flexDirection: "column" }}
        >
          <Bouncy color="#c33" size="60" speed="1.5" />
          <p className="text-xl text-ax-secondary">Loading...</p>
        </div>
      </div>
      <Script
        id="branch-locator-script"
        src="https://uberall.com/assets/storeFinderWidget-v2.js"
        type="application/javascript"
        onLoad={initUberall}
        onReady={initUberall}
      />
    </>
  );
};

export default BranchLocatorWidget;
